var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._b({attrs:{"value":_vm.value,"dense":"","outlined":"","clearable":_vm.clearable,"append-icon":"mdi-web"},on:{"input":function($event){return _vm.$emit('input', $event !== '' ? $event : null)},"click:append":function($event){return _vm.onAppendClick(_vm.value)}}},'v-text-field',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }